import React from 'react';
import Picker from 'react-mobile-picker';
import {
  Container,
  TopRow,
  PickerValue,
  StyledPickerWrapper,
  DropdownArrow,
  Label,
  ActionContainer,
} from './styles';

const CustomNumericPicker = (props) => {
  const {
    pointId,
    currentValue,
    symbol,
    config = {},
    handleValueChange,
    activePickerId,
    handleNumericClick,
    label,
    actionSection,
  } = props;
  const { customEnum } = config;
  const step = customEnum?.step ? parseFloat(customEnum?.step) : 1;
  const min = customEnum?.min ? parseFloat(customEnum?.min) : 0;
  const max = customEnum?.max ? parseFloat(customEnum?.max) : 100;
  const currentVal =
    currentValue !== null && currentValue !== undefined ? parseFloat(currentValue) : null;

  //  picker function
  const renderPicker = (pointId, currentValue) => {
    const currentVal =
      currentValue !== null && currentValue !== undefined ? parseFloat(currentValue) : min;

    // Generate array of values based on step
    const values = [];
    for (let i = min; i <= max; i += step) {
      values.push(`${i}${symbol ? ' ' + symbol : ''}`);
    }

    // Find the closest valid value
    const closestValue =
      values.find((val) => parseFloat(val) === currentVal) ||
      values.reduce((prev, curr) =>
        Math.abs(parseFloat(curr) - currentVal) < Math.abs(parseFloat(prev) - currentVal)
          ? curr
          : prev
      );

    const optionGroups = { value: values };
    const valueGroups = { value: closestValue };

    return (
      <StyledPickerWrapper>
        <Picker
          optionGroups={optionGroups}
          valueGroups={valueGroups}
          onChange={(name, displayValue) => {
            // Extract numeric value from display string
            const numericValue = parseFloat(displayValue.split(' ')[0]);
            handleValueChange(pointId, numericValue);
          }}
          wheel="normal"
          height={150}
          itemHeight={30}
        />
      </StyledPickerWrapper>
    );
  };

  //  layout - picker-style display
  let displayValue, beforeValue, afterValue;

  if (currentVal !== null && !isNaN(currentVal)) {
    displayValue = currentVal;
    beforeValue = currentVal - step;
    afterValue = currentVal + step;
  } else {
    displayValue = '--';
    beforeValue = min + step;
    afterValue = min + 2 * step;
  }

  return (
    <Container key={pointId}>
      <TopRow>
        <TopRow>
          <Label>{label}</Label>
          <PickerValue onClick={(e) => handleNumericClick(pointId, e)}>
            {displayValue} {symbol}
            <DropdownArrow />
          </PickerValue>
        </TopRow>
        <ActionContainer>{actionSection(pointId)}</ActionContainer>
      </TopRow>
      {activePickerId === pointId && renderPicker(pointId, currentValue, config)}
    </Container>
  );
};

export default CustomNumericPicker;
